import React, { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { collection, onSnapshot } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function ChangeLogsPage() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "changeLogs"), (snap) => {
      const data = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      // ✅ Zamanı her formatta doğru çözen fonksiyon
      const toTime = (t) => {
        if (!t) return 0;
        if (t?.toDate) return t.toDate().getTime(); // Firestore Timestamp
        if (typeof t === "number") return t;
        if (typeof t === "string") {
          // TR format: "05.11.2025 15:27:54"
          if (t.includes(".")) {
            const [datePart, timePart = "00:00:00"] = t.split(" ");
            const [day, month, year] = datePart.split(".").map(Number);
            const [hour, minute, second] = timePart.split(":").map(Number);
            return new Date(year, month - 1, day, hour, minute, second).getTime();
          }
          // ABD vb. formatlar
          const dt = new Date(t);
          if (!isNaN(dt)) return dt.getTime();
        }
        return 0;
      };

      // ✅ Normalize + Saat sıralaması yeni → eski
      const sorted = data
        .map((r) => ({ ...r, _time: toTime(r.time) }))
        .sort((a, b) => b._time - a._time);

      setLogs(sorted);
    });

    return () => unsub();
  }, []);

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(logs);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ChangeLogs");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf]), "ChangeLogs.xlsx");
  };

  const navigate = useNavigate();


  const BulkBadge = () => (
    <span
      style={{
        background: "#0d6efd",
        color: "#fff",
        fontSize: 10,
        fontWeight: 900,
        padding: "2px 8px",
        borderRadius: 12,
        marginLeft: 8,
        letterSpacing: "0.6px",
      }}
      title="Bulk operation"
    >
      BULK
    </span>
  );


  return (
    <div style={{ padding: 20, height: "100vh", overflowY: "auto" }}>
      <h3>🧾 Change Logs</h3>

      <button
        onClick={() => navigate(-1)}
        style={{
          position: "fixed",
          top: "10px",
          right: "10px",
          width: "32px",
          height: "32px",
          background: "#303030ff",      // Normal kırmızı
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          cursor: "pointer",
          zIndex: 2000,
          boxShadow: "0 2px 6px rgba(0,0,0,0.20)",
          transition: "0.2s"
        }}
        onMouseEnter={(e) => (e.target.style.background = "#bbb5b5ff")}  // Daha koyu kırmızı
        onMouseLeave={(e) => (e.target.style.background = "#414141ff")}  // Normal kırmızı
      >
        ←
      </button>

      {logs.length > 0 && (
        <button
          onClick={exportExcel}
          style={{
            background: "#28a745",
            color: "#fff",
            marginBottom: 10,
            border: "none",
            padding: "6px 12px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          📥 Export Excel
        </button>
      )}

      <div className="table-container" style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Project</th>
              <th>Zone</th>
              <th>Location</th>
              <th>Old Date</th>
              <th>New Date</th>
               <th>Game Type</th>
              <th>Reason</th>
              <th>Description</th>
              <th>User</th>
              <th>Time</th>
              <th>Reality</th> {/* ✅ */}
              <th>Status</th>

            </tr>
          </thead>

          <tbody>
            {logs.map((l, i) => (
              <tr
                key={i}
                style={{
                  background:
                    l.type === "BULK" || l.bulk
                      ? "rgba(13,110,253,0.06)"
                      : "transparent",
                }}
              >
                <td>{l.project}</td>
                <td>{l.zone}</td>
                <td>{l.location}</td>
                <td>{l.oldDate}</td>
                <td>{l.newDate}</td>
                 <td style={{ textAlign: "center" }}>
        {l.newGameType || l.oldGameType ? (
          <span
            style={{
              fontSize: 10,
              fontWeight: 800,
              padding: "2px 6px",
              background: "#e9ecef",
              color: "#000",
              borderRadius: 6,
              textTransform: "uppercase",
              letterSpacing: "0.4px",
            }}
          >
            🎮 {l.newGameType || l.oldGameType}
          </span>
        ) : (
          "-"
        )}
      </td>
                <td>{l.reason}</td>
                <td
                  style={{
                    fontWeight: l.type === "BULK" ? 700 : 400,
                    color: l.type === "BULK" ? "#0d6efd" : "#000",
                  }}
                >
                  {l.description || "-"}
                </td>
                <td>{l.user}</td>
                <td>
                  {l.time?.toDate
                    ? l.time.toDate().toLocaleString("tr-TR")
                    : l.time}
                </td>
                <td>
                  {l.isReality ? (
                    <span
                      style={{
                        background: "#000",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 6,
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                      }}
                    >
                      🎬 REALITY
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  <span
                    style={{
                      fontWeight: "bold",
                      color:
                        l.status === "Deleted"
                          ? "#dc3545"
                          : l.status === "Updated"
                            ? "#007bff"
                            : l.status === "Created"
                              ? "#28a745"
                              : "#333",
                    }}
                  >
                    {l.status || "-"}
                  </span>

                  {(l.type === "BULK" || l.bulk) && <BulkBadge />}
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
